import React, { type FC } from 'react';
import { createPictureFactory, Picture } from '@funtech-int/yango-shared';

import styles from './GalleryCard.module.css';

const pictureFactory = createPictureFactory({
    fallback: {
        src: '1200x',
    },
});

interface GalleryCardProps {
    title?: string;
    subtitle?: string;
    backgroundImage?: string;
    foregroundImage?: string;
    altText?: string;
}

export const GalleryCard: FC<GalleryCardProps> = ({
    backgroundImage,
    foregroundImage,
    title,
    subtitle,
    altText = '',
}) => {
    const { img: backgroundImg } = pictureFactory({
        fallbackUrl: backgroundImage,
    });

    const { img: foregroundImg } = pictureFactory({
        fallbackUrl: foregroundImage,
    });

    return (
        <article className={styles.card}>
            <div className={styles.media}>
                {backgroundImage && (
                    <Picture
                        className={styles.backgroundImage}
                        alt={altText}
                        loading="lazy"
                        srcSet={backgroundImg.srcSet}
                        src={backgroundImg.src}
                        data-tid="AdaptiveImage"
                    />
                )}
                {foregroundImage && (
                    <Picture
                        className={styles.foregroundImage}
                        alt=""
                        role="presentation"
                        loading="lazy"
                        srcSet={foregroundImg.srcSet}
                        src={foregroundImg.src}
                        data-tid="AdaptiveImage"
                    />
                )}
            </div>

            {(title || subtitle) && (
                <div className={styles.cardContent}>
                    {title && <h3 className={styles.cardTitle}>{title}</h3>}
                    {subtitle && <p className={styles.cardSubtitle}>{subtitle}</p>}
                </div>
            )}
        </article>
    );
};
